<div class="toolbar-container" *ngIf="!!labsiteInformation && labsiteInformation.content && labsiteInformation.content.length < 50">
  <div  class="toolbar-content-lessContent">
    <span [innerHtml]="headerText"></span>
  </div>
</div>
<div class="toolbar-container" *ngIf="!!labsiteInformation && labsiteInformation.content && labsiteInformation.content.length >= 50 && labsiteInformation.content.length < 100">
  <div  class="toolbar-content-mediumContent">
    <span [innerHtml]="headerText"></span>
  </div>
</div>
<div class="toolbar-container" *ngIf="!!labsiteInformation && labsiteInformation.content && labsiteInformation.content.length >= 100">
  <div  class="toolbar-content">
    <span [innerHtml]="headerText"></span>
  </div>
</div>